module.exports = __webpack_public_path__ + "static/media/wa-logo.287bc2cc.svg";